// extracted by mini-css-extract-plugin
export default {"loading":"CAapGclcT506ekd5pWPh","placeHolderShimmer":"DM6B_Y4Sk_KEvM5BD2AD"};